export const RAILZ_API_HOST = 'https://api.railz.ai';
